import { render, staticRenderFns } from "./BatchNumbersInputs.vue?vue&type=template&id=141a22c0"
import script from "./BatchNumbersInputs.vue?vue&type=script&lang=js"
export * from "./BatchNumbersInputs.vue?vue&type=script&lang=js"
import style0 from "./BatchNumbersInputs.vue?vue&type=style&index=0&id=141a22c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports